import { ISettingsMap } from '@/models/settings.model';
import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getSettings, settingsSelector } from '../feature';

const useGetSettings = () => {
  const dispatch = useAppDispatch();
  const { error, isLoading, settings } = useAppState(settingsSelector);

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  const groupedSettings = useMemo(() => {
    const result = {} as Partial<ISettingsMap>;

    for (const item of settings || []) {
      result[item.type as keyof ISettingsMap] = item as never;
    }

    return result;
  }, [settings]);

  return useMemo(
    () => ({
      error,
      isLoading,
      settings,
      groupedSettings,
    }),
    [error, isLoading, settings, groupedSettings],
  );
};

export default useGetSettings;
